import { render } from "./CustomerBillingDashboard.vue?vue&type=template&id=651773e2&scoped=true"
import script from "./CustomerBillingDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerBillingDashboard.vue?vue&type=script&lang=js"

import "./CustomerBillingDashboard.vue?vue&type=style&index=0&id=651773e2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651773e2"]])

export default __exports__